import { 
    CREATEPATHOLOGYBILL, 
    CREATEPATHOLOGYBILLTEST, 
    CREATEPATHOLOGYBILLTRANSACTION, 
    CREATEPATHOLOGYTESTCOLLECTER, 
    CREATEPATHOLOGYTESTPARAMETERVALUE, 
    DELETEPATHOLOGYBILL, 
    DELETEPATHOLOGYBILLTEST, 
    DELETEPATHOLOGYBILLTRANSACTION, 
    DELETEPATHOLOGYTESTCOLLECTER, 
    DELETEPATHOLOGYTESTPARAMETERVALUE, 
    GETPATHOLOGYBILL, 
    GETPATHOLOGYBILLTEST, 
    GETPATHOLOGYBILLTRANSACTION, 
    GETPATHOLOGYTESTCOLLECTER, 
    GETPATHOLOGYTESTPARAMETERVALUE, 
    UPDATEPATHOLOGYBILL,
    UPDATEPATHOLOGYBILLTEST,
    UPDATEPATHOLOGYBILLTRANSACTION,
    UPDATEPATHOLOGYTESTCOLLECTER,
    UPDATEPATHOLOGYTESTPARAMETERVALUE
 } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEPATHOLOGYBILL:
            return {
                ...state,
                pathologybillSaveStatus: action.payload.success,
            }
        case GETPATHOLOGYBILL:
                return {
                        ...state,
                        pathologybillList: action.payload.data,
                        }
      
        case UPDATEPATHOLOGYBILL:
                return {
                        ...state,
                        pathologybillUpdateStatus: action.payload.success,
                        }   

        case DELETEPATHOLOGYBILL:
                 return {
                     ...state,
                     pathologybillDeleteStatus: action.payload.success,
                        } 
        case CREATEPATHOLOGYBILLTEST:
            return {
                ...state,
                pathologybilltestSaveStatus: action.payload.success,
            }
        case GETPATHOLOGYBILLTEST:
                return {
                        ...state,
                        pathologybilltestList: action.payload.data,
                        }
      
        case UPDATEPATHOLOGYBILLTEST:
                return {
                        ...state,
                        pathologybilltestUpdateStatus: action.payload.success,
                        }   

        case DELETEPATHOLOGYBILLTEST:
                 return {
                     ...state,
                     pathologybilltestDeleteStatus: action.payload.success,
                        }
                        
        case CREATEPATHOLOGYTESTCOLLECTER:
            return {
                ...state,
                pathologytestcollectorSaveStatus: action.payload.success,
            }
        case GETPATHOLOGYTESTCOLLECTER:
                return {
                        ...state,
                        pathologytestcollecterList: action.payload.data,
                        }
      
        case UPDATEPATHOLOGYTESTCOLLECTER:
                return {
                        ...state,
                        pathologytestcollecterUpdateStatus: action.payload.success,
                        }   

        case DELETEPATHOLOGYTESTCOLLECTER:
                 return {
                     ...state,
                     pathologytestcollecterDeleteStatus: action.payload.success,
                        }
        case CREATEPATHOLOGYBILLTRANSACTION:
            return {
                ...state,
                    pathologybilltransactionSaveStatus: action.payload.success,
            }
        case GETPATHOLOGYBILLTRANSACTION:
                return {
                        ...state,
                        pathologybilltransactionList: action.payload.data,
                        }
      
        case UPDATEPATHOLOGYBILLTRANSACTION:
                return {
                        ...state,
                        pathologybilltransactionUpdateStatus: action.payload.success,
                        }   

        case DELETEPATHOLOGYBILLTRANSACTION:
                 return {
                     ...state,
                     pathologybilltransactionDeleteStatus: action.payload.success,
                        } 

        case CREATEPATHOLOGYTESTPARAMETERVALUE:
            return {
                ...state,
                pathologytestparametervalueSaveStatus: action.payload.success,
            }
        case GETPATHOLOGYTESTPARAMETERVALUE:
                return {
                        ...state,
                        pathologytestparametervalueList: action.payload.data,
                        }
      
        case UPDATEPATHOLOGYTESTPARAMETERVALUE:
                return {
                        ...state,
                        pathologytestparametervalueUpdateStatus: action.payload.success,
                        }   

        case DELETEPATHOLOGYTESTPARAMETERVALUE:
                 return {
                     ...state,
                     pathologytestparametervalueDeleteStatus: action.payload.success,
                        }
                        default:
                            return state
                             }
                         }